import React, { useEffect } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ERROR_BOUNDARY_PACKAGE } from '../../common/constants.tsx';
import { useNextBestTaskActions } from '../../services/next-best-task-container/index.tsx';

type Props = { isOnlyCurrentUserSelected: boolean };

const NBTDataLoaderForOnlyCurrentUserSelected = ({ isOnlyCurrentUserSelected }: Props) => {
	const { setIsOnlyCurrentUserSelected } = useNextBestTaskActions();

	useEffect(() => {
		if (setIsOnlyCurrentUserSelected != null) {
			setIsOnlyCurrentUserSelected(isOnlyCurrentUserSelected);
		}
	}, [isOnlyCurrentUserSelected, setIsOnlyCurrentUserSelected]);

	return null;
};

const NBTDataLoaderForOnlyNBTEnabledAvatarSelected = ({
	isOnlyNBTEnabledAvatarSelected,
}: {
	isOnlyNBTEnabledAvatarSelected: boolean;
}) => {
	const { setIsOnlyNBTEnabledAvatarSelected } = useNextBestTaskActions();

	useEffect(() => {
		if (setIsOnlyNBTEnabledAvatarSelected != null) {
			setIsOnlyNBTEnabledAvatarSelected(isOnlyNBTEnabledAvatarSelected);
		}
	}, [setIsOnlyNBTEnabledAvatarSelected, isOnlyNBTEnabledAvatarSelected]);

	return null;
};

export const SafeNBTDataLoaderForOnlyNBTEnabledAvatarSelected = ({
	isOnlyNBTEnabledAvatarSelected,
}: {
	isOnlyNBTEnabledAvatarSelected: boolean;
}) => (
	<JSErrorBoundary
		id="filter-data-loader"
		packageName={ERROR_BOUNDARY_PACKAGE}
		fallback="unmount"
		teamName="nova"
	>
		<NBTDataLoaderForOnlyNBTEnabledAvatarSelected
			isOnlyNBTEnabledAvatarSelected={isOnlyNBTEnabledAvatarSelected}
		/>
	</JSErrorBoundary>
);

export const SafeNBTDataLoaderForOnlyCurrentUserSelected = ({
	isOnlyCurrentUserSelected,
}: Props) => (
	<JSErrorBoundary
		id="filter-data-loader"
		packageName={ERROR_BOUNDARY_PACKAGE}
		fallback="unmount"
		teamName="nova"
	>
		<NBTDataLoaderForOnlyCurrentUserSelected
			isOnlyCurrentUserSelected={isOnlyCurrentUserSelected}
		/>
	</JSErrorBoundary>
);
